module.exports = __webpack_public_path__ + "img/blog-8.9178a378.jpg";